/* eslint-disable no-undef,no-underscore-dangle */

import { createStore, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk';
import rootReducer from './reducers'
import {authInitialState} from '../redux/auth/authInitalState'
import {projectInitialState} from '../redux/project/projectInitalState'
import {metasInitialState} from '../redux/meta/metaInitalState'

const middleware = [thunk];

/** @namespace window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ */
const composeEnhancers =
    typeof window === 'object' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
        ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
        }) : compose;

const enhancer = composeEnhancers(applyMiddleware(...middleware));

const initalState = {
    auth: authInitialState,
    project: projectInitialState,
    meta: metasInitialState
}

const store = createStore(
    rootReducer,
    initalState,
    enhancer
);

export default store
